module.exports = __webpack_public_path__ + "assets/img/email-9ff285f0.png";